"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCounter = exports.StyledIcon = exports.AlertCounterWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_utils_1 = require("../sidebar/utils/styled-utils");
exports.AlertCounterWrapper = styled_components_1.default.div `
  position: relative;
  display: inline-flex;
`;
exports.StyledIcon = (0, styled_components_1.default)(wl_ui_kit_1.Icon) ``;
exports.StyledCounter = styled_components_1.default.div `
  ${wl_ui_kit_1.Subtitle1Styles};
  position: absolute;
  top: 0;
  left: calc(100% + ${(0, wl_ui_kit_1.getSizeBy)(0.5)});
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(0, wl_ui_kit_1.getSizeBy)(3)};
  padding: 0 ${(0, wl_ui_kit_1.getSizeBy)()} 0 ${(0, wl_ui_kit_1.getSizeBy)()};
  color: ${({ $counterColor }) => (0, styled_utils_1.getCounterColor)($counterColor)};
  font-size: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  background-color: ${({ $counterBackgroundColor }) => (0, styled_utils_1.getCounterColor)($counterBackgroundColor)};
  border-radius: ${(0, wl_ui_kit_1.getSizeBy)(25)};
  transform: translateX(-100%);
`;
